export default __webpack_public_path__ + "static/media/DTM_Scherer_SE.7fa190d5.jpg";